import { render, staticRenderFns } from "./ReMenChengshi.vue?vue&type=template&id=95c8a458&scoped=true&"
import script from "./ReMenChengshi.vue?vue&type=script&lang=js&"
export * from "./ReMenChengshi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c8a458",
  null
  
)

export default component.exports